import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const DataImportItemsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>Data Import Items</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(atlasRoutes.dataImportItemsView({ params: { dataImportItemId: uuid } }).path)
        }
      />
    </div>
  );
};
